<template>
  <div>
    <CommonWords :messageType="1" :username="userInfo.userName"></CommonWords>
  </div>
</template>

<script>
  import CommonWords from '@/views/IM/model/commonWords'
  import { localRead } from '@/utils/tools'

  export default {
    name: 'personalPhrases',
    components: { CommonWords },
    data(){
      return{
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
      }
    },
  }
</script>
